import styled from 'styled-components';

export const UserDisplayStyled = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 8px;
`;

export const NameStyled = styled.p`
	margin-bottom: 0;
	text-overflow: ellipsis;
	font-weight: 400;
	font-size: 14px;
`;

export const LoginStyled = styled.p`
	overflow: hidden;
	margin-bottom: 0;
	color: #8c8c8c;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-weight: 400;
	font-size: 12px;
`;
